import { render } from "./EditingMediaAlbum.vue?vue&type=template&id=36e694b1"
import script from "./EditingMediaAlbum.vue?vue&type=script&lang=js"
export * from "./EditingMediaAlbum.vue?vue&type=script&lang=js"
script.render = render

export default script